export function formatEUR(cents) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
    (cents || 0) / 100
  );
}

export const FREE_SHIPPING_THRESHOLD = 4000; // 40,00 €
export const SHIPPING_FEE = 290; // 2,90 €
export const HALLOWEEN_TARGET = new Date("2026-10-31T23:59:59");
export const PROMO_CODE = "FRISSON20";
export const PROMO_PERCENT = 20;
export const PROMO_MIN = 2500; // code promo valable dès 25,00 €

// Quantity deals keyed by lookup_key: buy `qty` -> billed `price` per pack
export const DEALS = {
  cm_araignee_led: { qty: 2, price: 1090, label: "2 pour 10,90 €" },
  cm_nappe: { qty: 2, price: 1890, label: "2 pour 18,90 €" },
  cm_ballons_set: { qty: 2, price: 1890, label: "2 pour 18,90 €" },
  cm_stickers_halloween: { qty: 2, price: 1590, label: "2 pour 15,90 €" },
};

export function lineTotal(item) {
  const deal = DEALS[item.lookup_key];
  if (deal) {
    const packs = Math.floor(item.quantity / deal.qty);
    const singles = item.quantity % deal.qty;
    return packs * deal.price + singles * item.price;
  }
  return item.price * item.quantity;
}

export function cartSubtotal(items) {
  return items.reduce((s, i) => s + lineTotal(i), 0);
}

export function itemDeal(item) {
  const deal = DEALS[item.lookup_key];
  return deal && item.quantity >= deal.qty ? deal : null;
}
